export default __webpack_public_path__ + "static/media/warningFilled.4144a2f8.svg";